import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {GlossaryButton} from 'shells/glossary-button/glossary-button';

import {analyticsClient} from '../../../analytics-client';
import type {NutshellState} from '../../../store';

import {openSidebar} from '../redux/glossary-actions';
import {getIsButtonExpanded} from '../redux/glossary-selectors';

import {pageHasGlossary} from './helpers';

type Props = {
    glossaryKey?: string;
};

export function GlossarySidebarButton(props: Props) {
    const glossaryKey = props.glossaryKey || window.location.pathname;

    const dispatch = useDispatch();
    const isButtonExpanded = useSelector((state: NutshellState) => getIsButtonExpanded(state));

    // Don't show button if the page doesn't have a glossary or when in embedded mode
    if (!pageHasGlossary(glossaryKey) || window.location.host.includes('embed')) {
        return null;
    }

    return (
        <GlossaryButton
            onClick={() => {
                dispatch(openSidebar(glossaryKey));
                analyticsClient.track('glossary_opened', {glossaryKey});
            }}
            isExpanded={isButtonExpanded}
        />
    );
}
